import { uniq } from '@components/utils';

export function getUnmappedColumns({ headers, hidden_column_ids, mapping }: CustomerImport): number[] {
  const errors: number[] = [];
  for (let i = 0; i < headers.length; i++) {
    if (!mapping[i] && !hidden_column_ids.includes(i)) {
      errors.push(i);
    }
  }
  return errors;
}

export const isMissingUniqueId = ({ hidden_column_ids, id_attr, mapping }: CustomerImport): string | undefined => {
  const uniqueIdIndicies: number[] = new Array(mapping.length)
    .fill(0)
    .map((_, i) => i)
    .filter((i) => mapping[i] === id_attr);
  const uniqueIdsHidden: boolean =
    hidden_column_ids.length > 0 && uniqueIdIndicies.every((i) => hidden_column_ids.includes(i));

  if (!mapping.includes(id_attr) || uniqueIdsHidden) {
    return id_attr.replace('extra:', '');
  }
};

export const hasMultipleUniqueIds = (customerImport: CustomerImport, forceValidation: boolean = false): boolean => {
  const { id_attr, existing_candidates_count } = customerImport;
  const CORE_ID_ATTRS = ['email', 'phone_number'];

  // Only validate when we have reliable data OR when explicitly forced (Review & Import flow)
  if (!forceValidation && existing_candidates_count === 0) {
    // If existing_candidates_count is 0, we can't trust it yet unless validation is forced
    // This prevents false positives during initial validation before backend calculates counts
    return false;
  }

  // Custom unique identifiers are only allowed when there are existing candidates to update
  // If all candidates are new, email must be used as the unique identifier
  if (!CORE_ID_ATTRS.includes(id_attr) && existing_candidates_count === 0) {
    return true;
  }

  return false;
};

export const getDuplicateMappings = ({ hidden_column_ids, mapping }: CustomerImport): string[] => {
  const mappingWithoutHidden = mapping.map((m, i) => (hidden_column_ids.includes(i) ? null : m));

  return uniq(mapping.filter((m, i) => !!m && mappingWithoutHidden.indexOf(m) !== mappingWithoutHidden.lastIndexOf(m)));
};
